import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  selectActualDefaultLanguage,
  selectActualPermissions,
  selectIsStaticSalesDemo,
} from 'containers/App/selectors'
import { selectGroupSettingsName } from 'containers/Settings/selectors'

import LandingForm from 'components/pages/settings/mailboxProtection/LandingForm'

import actions from './actions'
import { selectData, selectError, selectLoader } from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  data: selectData(state),
  loader: selectLoader(state),
  error: selectError(state),
  permissions: selectActualPermissions(state),
  groupSettingsNameByPartner: selectGroupSettingsName(state),
  defaultLanguage: selectActualDefaultLanguage(state),
  isStaticSalesDemo: selectIsStaticSalesDemo(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(LandingForm)

export default withRouter(render)
